module.exports = __webpack_public_path__ + "img/fansbg.b5a80f0a.jpg";